export default "__VITE_ASSET__c0d38001__"